import api from "@/api";
import * as types from "./mutation-types";
import { initialState, mockState } from "./state";

export const actions = {
  /**
   * Set the currentPoll to its initial state
   */
  getBasePoll({ commit }) {
    return new Promise((resolve) => {
      commit(types.SET_POLL, { ...initialState });
      resolve(initialState);
    });
  },
  /**
   * Method to list all banners available
   * Allows for search and pagination
   */
  async list({ commit, state }, options) {
    let response;

    let endpoint = "/surveymanagement/polls/flat";

    const page = options && options.page ? options.page : 1;
    const size = state.pagination.per_page;
    let from = size * page - size;

    if (!from) {
      from = 0;
    }

    const filter = {
      size,
      from,
      sort: [
        {
          [state.sortBy.field]: {
            order: state.sortBy.direction,
          },
        },
      ],
      query: {
        bool: {
          must: [
            {
              bool: {
                should: [
                  {
                    match: {
                      poll_title: {
                        query: state.filters.searchQuery,
                        operator: "and",
                        zero_terms_query: "all",
                        fuzziness: "AUTO",
                      },
                    },
                  },
                  {
                    match_phrase_prefix: {
                      poll_title: {
                        query: state.filters.searchQuery,
                        slop: 50,
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    };

    try {
      // response = await api().post(endpoint, { filter })
      response = await api().put(endpoint, {filter});

      if (response) {
        const { poll } = response.data.data;
        commit(types.SET_FILTER_TOTAL, response.data.meta.filter_total);
        commit(types.SET_CURRENT_PAGE, page);
        commit(types.LIST_POLLS, poll);
        return Promise.resolve(poll);
      } else {
        commit(types.LIST_POLLS, []);
        return Promise.reject(new Error(err));
      }
    } catch (err) {
      if (err.response.status === 404 && err.response.data.data.length === 0) {
        return Promise.resolve([]);
      }
      return Promise.reject(new Error(err));
    }
  },

  /**
   * Create a new poll
   */
  async create({ state, dispatch }, payload) {
    let resp;

    try {
      resp = await api().post("surveymanagement/poll", {
        poll: payload,
      });
      return Promise.resolve(resp);
    } catch (err) {
      console.log("TCL:  ~ file: actions.js ~ line 108 ~ create ~ err", err);
      return Promise.reject(err);
    }
  },

  /**
   * Update a poll
   */
  async update({ state, dispatch }, payload) {
    let resp;
    const { id } = state.currentPoll;
    try {
      resp = await api().post(`surveymanagement/poll/${id}`, {
        poll: payload,
      });
      return Promise.resolve(resp);
    } catch (err) {
      console.log("TCL:  ~ file: actions.js ~ line 108 ~ create ~ err", err);
      return Promise.reject(err);
    }
  },

  /**
   * Delete a poll
   */
  async delete({ dispatch }, id) {
    let resp;

    try {
      await api().delete(`surveymanagement/poll/${id}`);
      dispatch("list");
      return Promise.resolve();
    } catch (err) {
      return Promise.reject();
    }
  },

  /**
   * Load a poll
   */
  async load({ commit }, id) {
    let poll;

    try {
      poll = await api().get(`/surveymanagement/poll/${id}`);
      console.log("TCL:  ~ file: actions.js ~ line 130 ~ load ~ poll", poll);
      const pollData = poll.data.data.poll[0];
      if (!pollData.options) {
        pollData.options = [];
      }
      commit(types.SET_POLL, pollData);
      return Promise.resolve(pollData);
    } catch (err) {
      commit(types.SET_POLL, {});
      return Promise.resolve({});
    }
  },

  /**
   * Get poll results
   */
  async getResults({ commit }, id) {
    let response;
    try {
      response = await api().get(`/surveymanagement/poll/${id}/entries/flat`);
      commit(types.SET_ENTRIES, response.data.data.entry);
    } catch (err) {
      console.log(
        "TCL:  ~ file: actions.js ~ line 190 ~ getResults ~ err",
        err
      );
    }
  },

  /**
   * Get submissions, allow us to filter by user
   */
  async getEntries({ commit, rootState }, params) {
    let response;
    let filter = {};

    if (params && params.currentUser) {
      filter = {
        filter: {
          query: {
            bool: {
              must: {
                term: {
                  user_id: rootState.auth.currentUser.id,
                },
              },
            },
          },
        },
      };
    }

    try {
      if (params.currentUser) {
        response = await api().put(
          `/surveymanagement/polls/${params.formId}/entries/flat`,
          filter
        );
      } else {
        response = await api().get(
          `/surveymanagement/polls/${params.formId}/entries/flat`
        );
      }
      if (params.saveToState) {
        commit(types.SET_ENTRIES, response.data.data.entry);
      }
      return Promise.resolve(response.data.data.entry);
    } catch (err) {
      if (params.saveToState) {
        commit(types.SET_ENTRIES, []);
      }
      return Promise.resolve([]);
    }
  },

  /**
   * Save answer
   */
  async setAnswer(context, { answer, pollId }) {
    console.log(
      "TCL:  ~ file: actions.js ~ line 168 ~ setAnswer ~ answer",
      answer
    );

    // only need certain bits for the answer
    const { id, name, value } = answer;

    const payload = {
      entry: {
        options: [
          {
            id,
            name,
            value,
          },
        ],
      },
    };

    await api().post(`/surveymanagement/poll/${pollId}/entry`, payload);
  },
};
